export const environment = {
  production: true,
  ENABLE_DEBUG: false,
  RESERVE_URL: 'https://bff-tablereservation.grupomadero.com.br',
  CRYPTO_AES_KEY: '9sCjYHX5fSHzWYDXxy0ga1IGu8H5fOSeW3PyOQiHtos=',
  CRYPTO_AES_IV: 'VmKzixu+AnLDZZ2dp4MhTw==',
  WAITING_LIST_POLLING_INTERVAL_MS: 30000,
};
